import * as React from "react";
import { makeStyles, Button } from "@fluentui/react-components";

import { backgroundColorSeaGreen, backgroundColorSeaGreenHover, backgroundColorSeaGreenActive } from "../styles/styles";

const useStyles = makeStyles({
  button: {
    backgroundColor: backgroundColorSeaGreen,
    "&:hover": {
      backgroundColor: backgroundColorSeaGreenHover,
    },
    "&:hover:active": { backgroundColor: backgroundColorSeaGreenActive },
  },
});

export default function PrimaryButton({ children, ...props }) {
  const styles = useStyles();
  const isDisabled = props["disabled"];

  if (!isDisabled) {
    props["className"] = styles.button;
  }

  return (
    <Button as="button" appearance="primary" {...props}>
      {children}
    </Button>
  );
}
